import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-penal',
  templateUrl: './penal.component.html',
  styleUrls: ['./penal.component.scss']
})
export class PenalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
